<template>
	<div class="col-12 pt-3 pb-3 color-black">
		<div class="col-12 cus-box-shadow rounded pt-2 pb-2 d-flex flex-wrap">
			<div class="col-4 col-md-1 col-lg-1 pl-0">
				<img class="img-fluid" :src="addedProduct.product_image_filename">
			</div>
			<div class="col-8 col-md-7 d-md-flex pr-0 pr-md-3 pl-0 pl-md-3 flex-wrap">
				<div class="col-12 col-lg-6 m-md-auto pl-0 pl-md-3 font-size-sm-11">{{addedProduct.product_name}}</div>
				<div class="col-12 col-md-6 col-lg-4 m-lg-auto pl-0 pl-md-3 f-lato font-size-sm-11">{{addedProduct.product_price | toRupiah}} / {{addedProduct.product_unit}}</div>
				<div class="col-12 col-md-6 col-lg-2 m-lg-auto f-lato pl-0 pl-md-3 pl-lg-0 font-size-sm-10">{{addedProduct.product_weight | toKg}}</div>
			</div>
			<div class="col-12 col-md-3 col-lg-4 m-md-auto text-right pl-0 pl-md-3 pr-0 pt-3 pt-md-0">
				<router-link class="col-12 col-lg-6 btn background-button-template color-white box-purple" :to="{ name: 'cart'}">
					<div class="pt-1 pb-1 font-size-11 font-size-sm-10 font-weight-bold">Lihat Keranjang</div>
				</router-link>
			</div>
		</div>
		<div class="font-weight-bold font-size-sm-11 pt-4 mt-2" v-if="from == 'stockist'">Silahkan cari produk lain di Mobile Counter ini</div>
		<div class="font-weight-bold font-size-sm-11 pt-4 mt-2" v-else>Rekomendasi Produk Untuk Anda</div>
		<div class="col-12 pb-4 d-flex flex-wrap pl-0 pr-0">
			<carousel ref="carousel" id="owl-menu" class="col-12 pl-0 pr-0 pt-2 pb-2" :responsive="{0:{items:1},600:{items:2},1000:{items:3}}" :margin="20" :autoplay="true" :nav="false" :loop="false" :dots="true">
				<div class="col-12 background-white rounded hov-cus-shadow pt-3 pb-3 mb-2 mr-2" v-for="(product, index) in recommend" :key="index">
					<div class="col-12 d-flex pl-0 pr-0 box-product-modal">
						<div class="col-6 pl-0">
							<img :src="product.product_image_filename" class="img-fluid rounded" alt="">
						</div>
						<div class="col-6 pl-0 pr-0">
							<div class="color-mila font-weight-bold font-size-sm-11 font-size-12">{{ product.product_name }}</div>
							<div class="color-purple font-size-sm-10 font-size-12 f-lato">Rp {{ product.product_price | toNumber }} / {{ product.product_unit }}</div>
							<div class="color-gray font-size-10 f-lato">{{ product.product_weight | toKg }}</div>
							<div class="color-black font-size-sm-9 font-size-10 pt-2">{{ product.product_description.slice(0, 60) }}...</div>
						</div>
					</div>
					<div class="col-12 mt-2 pl-0 pr-0 pt-0" v-if="from == 'stockist'">
						<button class="col-12 btn rounded background-button-template no-box-shadow color-white" @click="masukKeranjang(product)">
							<div class="pt-1 pb-1 font-size-11 font-size-sm-10"><i class="fas fa-shopping-cart mr-2"></i>
							Masukkan Keranjang</div>
						</button>
					</div>
					<div class="col-12 mt-3 pl-0 pr-0 pt-0" v-else>
						<router-link :to="{ name: 'product', params: { code: product.product_code }}" class="col-12 btn rounded background-button-template no-box-shadow color-white">
							<div class="pt-1 pb-1">
							Lihat Detail</div>
						</router-link>
					</div>
				</div>
			</carousel>
		</div>
	</div>
</template>
<script>
import carousel from 'vue-owl-carousel';

export default {
	components: {
		carousel
	},
	props : {
		addedProduct: {
			type: Object
		},
		recommend: {
			type: Array
		},
		from: {
			type: String
		}
	},
	methods: {
		masukKeranjang(product) {
			this.$emit('masukKeranjang', product)
		}
	},
}
</script>
<style>
</style>